import MicroModal from 'micromodal';

// unique ID generator
const existingIDs = [];
const getRandomLetters = (length = 1) =>
  Array(length)
    .fill()
    .map((e) => String.fromCharCode(Math.floor(Math.random() * 26) + 65))
    .join("");
const getRandomDigits = (length = 1) =>
  Array(length)
    .fill()
    .map((e) => Math.floor(Math.random() * 10))
    .join("");
const generateUniqueID = () => {
  let id = getRandomLetters(2) + getRandomDigits(4);
  while (existingIDs.includes(id))
    id = getRandomLetters(2) + getRandomDigits(4);
  return id;
};

class GalleryModal {
  constructor(uniqueId, galleryElement, config) {
    const defaults = {
      // submenuSelector: '.sub-menu',
      templateSelector: "#gallery-template",
      imageTemplateSelector: "#image-template",
      imageSelector: ".gallery-image",
      onInit: () => {},
      onImageInit: () => {},
      onBeforeOpenModal: () => {},
      // activeClass: 'is-open',
      // visibleClass: 'is-visible',
      // setScrollHeight: false
    };
    this.id = uniqueId;
    this.config = { ...defaults, ...config };
    this.container = galleryElement;
    //this.template = ;
    this.modal = null;

    if (!galleryElement) return;

    // generate modal html
    let temp = document.querySelector(this.config.templateSelector);
    let tempBody = document.importNode(temp.content, true);
    let galleryDiv = tempBody.firstElementChild;
    galleryDiv.setAttribute("id", this.id);
    document.body.appendChild(tempBody);

    // generate images inside modal
    let imageTemplate = galleryDiv.querySelector(
      this.config.imageTemplateSelector
    );
    let imagesParent = imageTemplate.parentNode;
    let images = this.container.querySelectorAll(this.config.imageSelector);

    images.forEach((image, index) => {
      let imageTemplateNode = document.importNode(imageTemplate.content, true);
      let imageNode = imageTemplateNode.firstElementChild;
      this.setupImageTemplate(imageNode, image, index);
      imagesParent.appendChild(imageTemplateNode);
    });

    this.config.onInit(galleryDiv);

    // events
    this.container
      .querySelectorAll(this.config.imageSelector)
      .forEach((image, index) => {
        image.addEventListener("click", (event) => {
          event.preventDefault();
          this.config.onBeforeOpenModal(image, index);
          this.openModal(image, index);
        });
      });

    galleryDiv
      .querySelectorAll(".gallery-modal-close")
      .forEach((element, index) => {
        element.addEventListener("click", (event) => {
          event.preventDefault();
          MicroModal.close(this.id);
        });
      });
  }

  setupImageTemplate(imageNode, image, index) {
    imageNode
      .querySelector("img")
      .setAttribute("src", image.getAttribute("href"));
    this.config.onImageInit(imageNode, image, index);
  }

  openModal(imageElement, index) {

    MicroModal.show(this.id, {
      onShow: (modal) => {},
      onClose: (modal) => {},
      openClass: "is-open",
      disableScroll: true,
      disableFocus: true,
      awaitOpenAnimation: false,
      awaitCloseAnimation: false,
      debugMode: false,
    });
  }
}

const dropdownAPI = {
  init: (galleryContainer, config = {}) => {
    const galleryElement =
      typeof galleryContainer === "string"
        ? document.querySelectorAll(galleryContainer)
        : galleryContainer?.length
        ? galleryContainer
        : [galleryContainer];
    galleryElement.forEach((gallery) => {
      const uID = generateUniqueID();
      new GalleryModal(uID, gallery, config);
    });
  },
};

export default dropdownAPI;
